import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { GetRulesMaxValuesList } from './types/getRulesMaxValuesList.types'
import { getRulesValuesList } from '.'

export const getRulesMaxValuesList: GetRulesMaxValuesList = (
  rules
) => (getRulesValuesList(rules) as number[][]).reduce<number[]>((acc, elem, idx) => {
  acc[idx] = Math.max(...elem)
  return acc
}, PARTICIPANTS_CATEGORIES.map(() => 0))
